export default ['Full-Time', 'Part-Time', 'Internship'];
